export interface CashAdvanceDetails {
  repay_optout: boolean;
  remaining_balance: number;
  status?: CashAdvanceStatus;
  current_paycheck_payment_amount: number;
}

export enum CashAdvanceStatus {
  QUEUED = 'Queued',
  PENDING = 'Pending',
  ADVANCED = 'Advanced',
  REPAID = 'Repaid',
  CANCELED = 'Canceled',
}

export enum CashAdvanceRepaymentStatus {
  OPTED_OUT = 'OPTED_OUT',
  PLANNED = 'PLANNED',
  SENT_TO_PAYROLL = 'SENT_TO_PAYROLL',
  DEDUCTION_TAKEN = 'DEDUCTION_TAKEN',
  COMPLETED = 'COMPLETED',
  MISSED = 'MISSED',
  PARTIAL_COMPLETED = 'PARTIAL_COMPLETED',
  PARTIAL_DEDUCTION_TAKEN = 'PARTIAL_DEDUCTION_TAKEN',
  CANCELED = 'CANCELED',
}

export interface CashAdvanceRepayment {
  advance_taken_date: string;
  cash_advance_id: number;
  cash_repayment_id: number;
  advance_amount: number;
  status: CashAdvanceRepaymentStatus;
  repay_amount: number;
  deduction_date: string;
  repaymentDate: string; //frontend only
}

export interface CashAdvanceRepaymentViewItem {
  repaymentId: number;
  date: string;
  amount: number;
  status: string;
}

export interface CashAdvanceGating {
  version: string;
  decision: 'SHOW_WARNING' | 'REQUIRE_GATE';
  reasonCodes: ('WARNING_1' | 'WARNING_2' | 'HARD_GATE')[];
  advancesInSY: number;
  action: {
    key: string;
    route: string;
  };
  decisionId: string;
  issuedAt: string;
}

export enum CashAdvanceGatingRoute {
  CASH_ADVANCE_GATED = 'cash_advance_gated',
  CASH_ADVANCE_FINAL_WARNING = 'cash_advance_final_warning',
  CASH_ADVANCE_WARNING = 'cash_advance_warning'
}

export interface CashAdvance {
  latest_cash_advance_details: CashAdvanceDetails;
  existing_cash_advances: boolean;
  is_eligible: boolean;
  current_pay_date: string;
  next_pay_date: string;
  cut_off_date: string;
  next_eligible_date: string;
  cash_advance_options: {
    spending: {
      amount: number;
    };
  };
  cash_advance_repayments: CashAdvanceRepayment[];
  gating?: CashAdvanceGating;
}

export interface CashAdvancePayload {
  payload: CashAdvance;
}

export interface CashAdvancePost {
  amount: number;
  disbursement_destination_type: string;
  gating?: {
    version: string;
    decisionId: string;
    shown: boolean;
  };
}
